<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="updateSystemAttribute" class="mt-3">
            <b-form-group :label="this.$t('attribute.code')" label-cols-sm="3">
                <b-form-input :value="formData.code" readonly></b-form-input>
            </b-form-group>
            <b-form-group :label="this.$t('attribute.value')" label-cols-sm="3">
                <b-form-input v-model="formData.value" required></b-form-input>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <save-icon title="" />&nbsp;{{ $t('general.save') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>

<script>
/* eslint-disable */

export default {
    name: 'AttributeEditForm',
    props: {
        attribute: Object,
        kkmId: String,
        service: Object,
        refresh: Function
    },
    data () {
        return {
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                id: this.attribute.id,
                code: this.attribute.code,
                value: this.attribute.value
            }
        }
    },
    computed: {
        isDisabled() {
            return this.$store.getters.isLoading
        }
    },
    methods: {
        async updateSystemAttribute() {
            this.hideAlert();
            
            try {
                await this.service.updateAttribute({
                    ...this.formData,
                    kkmId: this.kkmId != null ? this.kkmId : null
                });

                this.showSuccessAlert = true;
                this.alert = this.$i18n.t('attribute.updatedMessage');
                
                await this.refresh();
            } catch (error) {
                console.error(error);

                this.displayAlert(error);
            }
        },
        hideAlert() {
            this.showAlert = false;
            this.showSuccessAlert = false;
            this.alert = '';
        },
        displayAlert(errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`);
            this.showAlert = true;
        }
    }
}
</script>
